/**
 * 픽업 · 수령 완료 (DeliveredScreen) — 픽업 플로우 종결 화면(#794).
 *
 * 파트너가 카운터에서 Entregar 를 눌러 `seated` 로 전이되면(상태 폴링 감지) 페이지가
 * {@link WaitlistPickupReadyScreen} 대신 이 화면으로 전환한다.
 *
 * @see #781 / admin#2111 설계 §7 / task-9 브리프
 */
import { Check } from 'lucide-react';
import { Button } from '@/components/ui/button';
import type { WaitlistStrings } from './strings';

interface WaitlistDeliveredScreenProps {
  t: WaitlistStrings;
  onReset: () => void;
}

export function WaitlistDeliveredScreen({ t, onReset }: WaitlistDeliveredScreenProps) {
  return (
    <div className="flex flex-1 flex-col items-center justify-center overflow-y-auto px-7 py-10 text-center">
      <div className="mb-[22px] grid size-[84px] place-items-center rounded-full bg-primary text-primary-foreground">
        <Check className="size-[42px]" />
      </div>
      <h1 className="m-0 mb-2 text-2xl font-extrabold leading-tight">{t.pkDeliveredTitle}</h1>
      <p className="m-0 mb-8 max-w-[300px] text-[15px] leading-relaxed text-muted-foreground">
        {t.pkDeliveredLead}
      </p>
      <Button size="lg" className="w-full max-w-[300px]" onClick={onReset}>
        {t.volverInicio}
      </Button>
    </div>
  );
}
